import { IFormatObjectEditable } from "..";
import { IFormatAlert } from "../IFormatAlert";
import { IObjectValidator } from "../IObjectValidator";
import { ObjectAlert } from "../alerts";
import { GraphObjectEditor } from "../objectEditors";
import { GraphKinds } from "../../../../documaker/domain/format/objects";

export class GraphObjectValidator implements IObjectValidator {
  public validate(object: IFormatObjectEditable): IFormatAlert[] {
    if (object instanceof GraphObjectEditor) {
      if (object.kind().getValue() === GraphKinds.Line) {
        return this.validateLineGraph(object);
      } else if (object.kind().getValue() === GraphKinds.RangeOfMotion) {
        return this.validateRangeOfMotion(object);
      }
    }
  }

  private validateLineGraph(object: GraphObjectEditor): ObjectAlert[] {
    const alerts: ObjectAlert[] = [];
    const behavior = object.lineGraphBehavior().getValue();
    if (!behavior.items || behavior.items.length < 1) {
      alerts.push(new ObjectAlert(object, "項目を設定してください。"));
    }

    behavior.items.forEach(item => {
      if (item.range.max <= item.range.min) {
        alerts.push(new ObjectAlert(object, "範囲数値の最大値を最小値より大きい数値に設定してください。"));
      }
  
      if (!item.pairs || item.pairs.length < 1) {
        alerts.push(new ObjectAlert(object, "項目の値取得エリアの設定をしてください。"));
      }  
    });
    return alerts;
  }

  private validateRangeOfMotion(object: GraphObjectEditor): ObjectAlert[] {
    const alerts: ObjectAlert[] = [];
    const behavior = object.rangeOfMotionBehavior().getValue();
    if (typeof behavior.range.min !== "number") {
      alerts.push(new ObjectAlert(object, "最小値を入力してください。"));
    }

    if (typeof behavior.range.max !== "number") {
      alerts.push(new ObjectAlert(object, "最大値を入力してください。"));
    }
    return alerts;
  }
}
